// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var Particles = require("../../../uikit/reason/Styles/Particles.bs.js");
var Link = require("next/link").default;
var Core__Date = require("@rescript/core/src/Core__Date.bs.js");
var MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactWindow = require("../../../reason/bindings/ReactWindow.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReactWindow$1 = require("react-window");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");
var TailwindMerge = require("tailwind-merge");
var GraphQLWSClient = require("../../../GraphQLWSClient.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ConversationsListItem = require("./ConversationsListItem.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
var ReactVirtualizedAutoSizer = require("react-virtualized-auto-sizer").default;
var ReactWindowInfiniteLoader = require("react-window-infinite-loader").default;
var ConversationsListRelay_query_graphql = require("../../../__generated__/ConversationsListRelay_query_graphql.bs.js");
var ConversationsListRelayPaginationQuery_graphql = require("../../../__generated__/ConversationsListRelayPaginationQuery_graphql.bs.js");
var ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");
var ConversationsListRelay_ConversationEventsSubscription_graphql = require("../../../__generated__/ConversationsListRelay_ConversationEventsSubscription_graphql.bs.js");

var getConnectionNodes = ConversationsListRelay_query_graphql.Utils.getConnectionNodes;

var convertFragment = ConversationsListRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = ConversationsListRelayPaginationQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = ConversationsListRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ConversationsListRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(ConversationsListRelay_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

var QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

var convertVariables = ConversationsListRelay_ConversationEventsSubscription_graphql.Internal.convertVariables;

var convertResponse = ConversationsListRelay_ConversationEventsSubscription_graphql.Internal.convertResponse;

var subscribe = RescriptRelay_Subscriptions.subscribe(ConversationsListRelay_ConversationEventsSubscription_graphql.node, convertVariables, convertResponse);

var Subscription = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  subscribe: subscribe
};

var InfiniteLoader = ReactWindow.InfiniteLoader(ReactWindow.FixedSizeInstance);

function ConversationsListRelay$FixedDimensionsComponent(props) {
  var loadMore = props.loadMore;
  var hasNextPage = props.hasNextPage;
  var items = props.items;
  var selectedConversationId = props.selectedConversationId;
  var width = props.width;
  var height = props.height;
  var itemCount = hasNextPage ? items.length + 1 | 0 : items.length;
  var isItemLoaded = function (idx) {
    if (hasNextPage) {
      return idx < items.length;
    } else {
      return true;
    }
  };
  var loadMore$1 = function (param, param$1) {
    return loadMore();
  };
  return JsxRuntime.jsx(ReactWindowInfiniteLoader, {
              isItemLoaded: isItemLoaded,
              itemCount: itemCount,
              loadMoreItems: loadMore$1,
              children: (function (param) {
                  return JsxRuntime.jsx(ReactWindow$1.FixedSizeList, {
                              height: height,
                              width: width,
                              itemCount: itemCount,
                              itemSize: 98.0,
                              onItemsRendered: param.onItemsRendered,
                              ref: param.ref,
                              overscanCount: 5,
                              children: (function (param) {
                                  var item = items[param.index];
                                  var tmp;
                                  if (item !== undefined) {
                                    var selected = selectedConversationId !== undefined ? selectedConversationId === item.id : false;
                                    tmp = JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Link, {
                                                href: "/conversations/" + item.id,
                                                className: "text-inherit hover:text-inherit active:text-inherit focus:text-inherit",
                                                children: Caml_option.some(JsxRuntime.jsx(ConversationsListItem.make, {
                                                          conversation: item.fragmentRefs
                                                        }))
                                              }),
                                          className: TailwindMerge.twMerge([
                                                "border-l-2 border-l-transparent border-b h-24",
                                                selected ? "border-l-tan-gold bg-gray-50" : ""
                                              ])
                                        }, item.id);
                                  } else {
                                    tmp = JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Loader.make, {
                                                size: "small"
                                              }),
                                          className: "h-24"
                                        });
                                  }
                                  return JsxRuntime.jsx("div", {
                                              children: tmp,
                                              style: param.style
                                            });
                                })
                            });
                })
            });
}

var FixedDimensionsComponent = {
  InfiniteLoader: InfiniteLoader,
  make: ConversationsListRelay$FixedDimensionsComponent
};

function ConversationsListRelay$AutosizedComponent(props) {
  var loadMore = props.loadMore;
  var items = props.items;
  var hasNextPage = props.hasNextPage;
  var selectedConversationId = props.selectedConversationId;
  return JsxRuntime.jsx(ReactVirtualizedAutoSizer, {
              children: (function (param) {
                  return JsxRuntime.jsx(ConversationsListRelay$FixedDimensionsComponent, {
                              height: param.height,
                              width: param.width,
                              selectedConversationId: selectedConversationId,
                              items: items,
                              hasNextPage: hasNextPage,
                              loadMore: loadMore
                            });
                })
            });
}

var AutosizedComponent = {
  make: ConversationsListRelay$AutosizedComponent
};

function useSelectFirstConversationOnDesktop(skipOpt, conversations, selectedConversationId) {
  var skip = skipOpt !== undefined ? skipOpt : false;
  var isDesktop = MediaQuery.useMediaQuery({
        TAG: "MinWidth",
        _0: Particles.Breakpoint.lg
      });
  var router = Next.useRouter();
  React.useEffect((function () {
          if (skip) {
            return ;
          }
          var match = conversations[0];
          if (isDesktop && !(selectedConversationId !== undefined || match === undefined)) {
            Next.Router.replace("/conversations/" + match.id, undefined, undefined, router);
          }
          
        }), [
        skip,
        conversations,
        isDesktop
      ]);
}

function ConversationsListRelay(props) {
  var selectedConversationId = props.selectedConversationId;
  var match = usePagination(props.query);
  var refetch = match.refetch;
  var loadNext = match.loadNext;
  var match$1 = React.useTransition();
  var startTransition = match$1[1];
  var items = getConnectionNodes(match.data.accountConversations);
  var selectedConversationIdRef = React.useRef(selectedConversationId);
  selectedConversationIdRef.current = selectedConversationId;
  useSelectFirstConversationOnDesktop(props.isNewConversation, items, selectedConversationId);
  items.sort(function (v1, v2) {
        var match = v1.lastMessage;
        if (match === undefined) {
          return 0;
        }
        var match$1 = v2.lastMessage;
        if (match$1 !== undefined) {
          return Core__Date.compare(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match$1.sentAt)), UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match.sentAt)));
        } else {
          return 0;
        }
      });
  var numItems = items.length;
  var refetchConversationList = React.useCallback((function () {
          startTransition(function () {
                refetch(makeRefetchVariables(undefined, Caml_option.some(numItems)), "network-only", undefined);
              });
        }), [
        refetch,
        startTransition,
        numItems
      ]);
  var wsIsClosed = React.useRef(false);
  var onWsStatusUpdated = React.useCallback((function (status) {
          var match = wsIsClosed.current;
          switch (status) {
            case "Closed" :
                wsIsClosed.current = true;
                return ;
            case "Connecting" :
                return ;
            case "Connected" :
                if (match) {
                  refetchConversationList();
                  wsIsClosed.current = false;
                  return ;
                } else {
                  return ;
                }
            
          }
        }), [refetchConversationList]);
  GraphQLWSClient.useOnWsStatusUpdated(onWsStatusUpdated);
  var environment = RescriptRelay.useEnvironmentFromContext();
  React.useEffect((function () {
          var subscription = subscribe(environment, {
                connections: [ConversationsListRelay_query_graphql.makeConnectionId(RelayRuntime.ROOT_ID)]
              }, undefined, undefined, undefined, (function (store, response) {
                  var match = response.conversationEvents;
                  if (match === undefined) {
                    return ;
                  }
                  switch (match.__typename) {
                    case "NewConversationReplyEvent" :
                        var match$1 = match.conversation;
                        if (match$1 === undefined) {
                          return ;
                        }
                        var match$2 = match.message;
                        if (match$2 === undefined) {
                          return ;
                        }
                        var conversationDataId = match$1.__id;
                        var match$3 = store.get(match$2.__id);
                        var match$4 = store.get(conversationDataId);
                        if (!(match$3 == null) && !(match$4 == null)) {
                          match$4.setLinkedRecord(match$3, "lastMessage");
                          if (selectedConversationIdRef.current !== match$1.id) {
                            return Core__Option.forEach(Caml_option.nullable_to_opt(store.get(ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversationDataId))), (function (conversationMessageConnectionProxy) {
                                          conversationMessageConnectionProxy.invalidateRecord();
                                        }));
                          } else {
                            return ;
                          }
                        } else {
                          return ;
                        }
                    case "NewConversationEvent" :
                    case "__unselected" :
                        return ;
                    
                  }
                }));
          return (function () {
                    subscription.dispose();
                  });
        }), []);
  return JsxRuntime.jsx(ConversationsListRelay$AutosizedComponent, {
              selectedConversationId: selectedConversationId,
              hasNextPage: match.hasNext,
              items: items,
              loadMore: (function () {
                  return new Promise((function (resolve, reject) {
                                loadNext(10, (function (e) {
                                        if (e !== undefined) {
                                          return reject();
                                        } else {
                                          return resolve();
                                        }
                                      }));
                              }));
                })
            });
}

var cardHeight = 98.0;

var make = ConversationsListRelay;

exports.QueryFragment = QueryFragment;
exports.Subscription = Subscription;
exports.cardHeight = cardHeight;
exports.FixedDimensionsComponent = FixedDimensionsComponent;
exports.AutosizedComponent = AutosizedComponent;
exports.useSelectFirstConversationOnDesktop = useSelectFirstConversationOnDesktop;
exports.make = make;
/* subscribe Not a pure module */
